import { HStack, Icon } from '@chakra-ui/react';
import { memo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  color?: string;
};

function CustomTitle({ children, color = 'neutral.black' }: Readonly<Props>) {
  return (
    <HStack
      height="40px"
      position="absolute"
      left="50%"
      transform="translateX(-50%)"
      top={0}
      gap={0}
      zIndex={3}
      fontFamily="roboto"
      userSelect="none"
    >
      <Icon width="20px" height="40px" viewBox="0 0 20 40" marginRight="-2px" color={color}>
        <svg width="20" height="40" viewBox="0 0 20 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 0L0 0L14 38L18 40L20 40L20 0Z" fill="currentColor" />
        </svg>
      </Icon>
      <HStack height="100%" gap={2} paddingX={2} paddingY={1} backgroundColor={color}>
        {children}
      </HStack>
      <Icon width="20px" height="40px" viewBox="0 0 20 40" marginLeft="-2px" color={color}>
        <svg width="20" height="40" viewBox="0 0 20 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0L20 0L6 38L2 40L0 40L0 0Z" fill="currentColor" />
        </svg>
      </Icon>
    </HStack>
  );
}

export default memo(CustomTitle);
